import { singleton } from 'tsyringe';
import { IOWIOPathsWrapper } from 'app-core/src/interfaces/ow-wrappers/ow-io-paths-wrapper.interface';

// -----------------------------------------------------------------------------
// NOTE(twolf): This is a (sort-of) wrapper that allows what relate to
// application level actions - such as shutting down the application.
@singleton()
export class OWIOPathsWrapper implements IOWIOPathsWrapper {
  // ---------------------------------------------------------------------------
  public get commonAppData() {
    return overwolf.io.paths.commonAppData;
  }

  // ---------------------------------------------------------------------------
  public get commonFiles() {
    return overwolf.io.paths.commonFiles;
  }

  // ---------------------------------------------------------------------------
  public get commonFilesX86() {
    return overwolf.io.paths.commonFilesX86;
  }

  // ---------------------------------------------------------------------------
  public get desktop() {
    return overwolf.io.paths.desktop;
  }

  // ---------------------------------------------------------------------------
  public get documents() {
    return overwolf.io.paths.documents;
  }

  // ---------------------------------------------------------------------------
  public get localAppData() {
    return overwolf.io.paths.localAppData;
  }

  // ---------------------------------------------------------------------------
  public get tempLocalAppData() {
    return `${overwolf.io.paths.localAppData}\\temp`;
  }
}
